<template>
  <button
    type="button"
    id="btn-microsoft-login"
    @click="handleClick"
    :disabled="loading"
    class="my-2"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
      <title>MS-SymbolLockup</title>
      <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
      <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
      <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
    </svg>
    
    <span style="color: #3c4043; margin-left: 12px; font-size: 15px;">
      Fazer login com a Microsoft
    </span>
    
    <div v-if="loading" class="btn-progress-track">
      <div class="btn-progress-bar"></div>
    </div>
  </button>
</template>

<script>
export default {
  name: 'MicrosoftLoginButton',
  data() {
    return {
      loading: false
    };
  },
  methods: {
    handleClick() {
      if (this.loading) return;
      this.apiGetAzureUrl();
    },
    toastAzureError(error) {
      const detail = (error && error.response && error.response.data && error.response.data.message)
        || 'Não foi possível iniciar o login com a Microsoft.';
      this.$toast.add({
        severity: 'error',
        summary: 'Atenção',
        detail: detail,
        life: 4000,
      });
    },
    async apiGetAzureUrl() {
      try {
        this.loading = true;
        const response = await this.axios.get('/auth/azure');
        if (response.data && response.data.url) {
          window.location.href = response.data.url;
          return;
        }
        this.toastAzureError(response);
      } catch (e) {
        this.toastAzureError(e);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style>
#btn-microsoft-login {
  position: relative;
  overflow: hidden;
  font-family: "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif;
  font-weight: 600;
  color: #5E5E5E;
  background-color: #FFFFFF;
  border: 1px solid #8C8C8C;
  padding: 0 12px;
  height: 38px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color .218s;
  border-radius: 4px;
}

#btn-microsoft-login:hover:not(:disabled) {
  background: rgba(66, 133, 244, .04);
}

#btn-microsoft-login:disabled {
  cursor: not-allowed;
  opacity: 0.9;
}

.btn-progress-track {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: rgba(0, 0, 0, 0.06);
}

.btn-progress-bar {
  width: 35%;
  height: 100%;
  background-color: #6c757d;
  border-radius: 2px;
  animation: ms-progress-indeterminate 1.2s infinite ease-in-out;
}

@keyframes ms-progress-indeterminate {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(320%);
  }
}
</style>